import { render, staticRenderFns } from "./SpotsOverview.vue?vue&type=template&id=0a4ca7c8&"
import script from "./SpotsOverview.vue?vue&type=script&lang=js&"
export * from "./SpotsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports